import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["shape", "animation"];
import React from 'react';
import styled from 'styled-components';
import { Box } from '../Box';
import { makeSkeletonShape, makeSkeletonAnimation, shouldForwardProp } from './utils';
var SkeletonComponent = styled(Box).withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "Skeleton__SkeletonComponent",
  componentId: "sc-1ol6tq0-0"
})(["", " ", " position:relative;overflow:hidden;"], makeSkeletonShape, makeSkeletonAnimation);
export var Skeleton = function Skeleton(_ref) {
  var _ref$shape = _ref.shape,
      shape = _ref$shape === void 0 ? 'squareRounded' : _ref$shape,
      _ref$animation = _ref.animation,
      animation = _ref$animation === void 0 ? 'wave' : _ref$animation,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(SkeletonComponent, _extends({
    bg: "grey.light",
    shape: shape,
    animation: animation
  }, rest));
};